import { Component, Input, OnChanges, SimpleChanges, SecurityContext, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-streaming-text',
  standalone: true,
  imports: [CommonModule],
  template: '<div [innerHTML]="displayedContent"></div>',
})
export class StreamingTextComponent implements OnChanges {
  @Input() content: string = '';
  @Input() isStreamingActive: boolean = true;
  @Output() contentUpdated = new EventEmitter<void>();
  displayedContent: SafeHtml = '';
  private interval: any;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      
      const newContent = changes['content'].currentValue || '';
      const sanitizedContent = this.sanitizer.sanitize(SecurityContext.HTML, newContent) || '';

      if (!this.isStreamingActive) {
        this.displayedContent = this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
        this.contentUpdated.emit();
        return;
      }
      
      const words = sanitizedContent.split(' ');
      let displayedWords: string[] = [];
      let i = 0;

      this.interval = setInterval(() => {
        if (i < words.length) {
          displayedWords.push(words[i]);
          this.displayedContent = this.sanitizer.bypassSecurityTrustHtml(displayedWords.join(' '));
          this.contentUpdated.emit();
          i++;
        } else {
          clearInterval(this.interval);
        }
      }, 10); // 10ms between words
    }
  }
}
